import type { SectionBlock } from '@site/shared'
import type { ContentQuery } from '@/lib/cms/queries'
import { HeroSection } from '@/components/sections/HeroSection'
import { CtaSection } from '@/components/sections/CtaSection'
import { ProseSection } from '@/components/sections/ProseSection'

export function BlockRenderer({ block }: { block: SectionBlock }) {
  switch (block.blockType) {
    case 'hero':  return <HeroSection block={block} />
    case 'cta':   return <CtaSection block={block} />
    case 'prose': return <ProseSection block={block} />
    default:      return null
  }
}

export function SectionList({ sections }: { sections: SectionBlock[] }) {
  return (
    <>
      {sections.map((block, i) => (
        <BlockRenderer key={i} block={block} />
      ))}
    </>
  )
}

/**
 * Extra CMS content each block type reads, for a route loader to prefetch on
 * the server. The shipped blocks carry all their content inline, so this is
 * empty today. When a block starts reading a collection through a hook (e.g.
 * a "latest posts" block using `useContent(contentQueries.posts())`), return
 * the SAME `contentQueries` descriptor here: the loader then prefetches the
 * exact cache key the component reads, and the block arrives in the server
 * HTML instead of loading after hydration.
 */
export function sectionQueries(sections: SectionBlock[]): ContentQuery<unknown>[] {
  return sections.flatMap((block): ContentQuery<unknown>[] => {
    switch (block.blockType) {
      default: return []
    }
  })
}
